import firebase from 'firebase/app';
import 'firebase/firestore';
import 'firebase/storage';
import 'firebase/auth';
import 'firebase/functions';

const config = {
  apiKey: process.env.REACT_APP_FIREBASE_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  databaseURL: process.env.REACT_APP_FIREBASE_DATABASE_URL,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
};

// Inicializar Firebase apenas se projectId estiver configurado
// Isso evita erros durante a migração para APIs REST
let api;
let apiLogin;

if (config.projectId) {
  try {
    api = firebase.initializeApp(config, 'Secondary');
    apiLogin = firebase.initializeApp(config);
  } catch (error) {
    console.warn('Firebase initialization failed:', error);
    // Criar objetos mock para evitar erros
    api = {
      firestore: () => ({
        collection: () => ({
          doc: () => ({
            get: () => Promise.resolve({ exists: false }),
            set: () => Promise.resolve(),
            update: () => Promise.resolve(),
            delete: () => Promise.resolve(),
            onSnapshot: () => () => {}, // Adicionar onSnapshot ao doc
          }),
          get: () => Promise.resolve({ docs: [] }),
          where: () => ({
            onSnapshot: () => () => {},
            get: () => Promise.resolve({ docs: [] }),
          }),
          orderBy: () => ({
            onSnapshot: () => () => {},
          }),
        }),
      }),
      auth: () => ({
        currentUser: null,
        onAuthStateChanged: () => () => {},
        sendPasswordResetEmail: () => Promise.resolve(),
      }),
      storage: () => ({
        ref: () => ({
          put: () => Promise.resolve({ ref: { getDownloadURL: () => Promise.resolve('') } }),
        }),
      }),
    };
    apiLogin = api;
  }
} else {
  console.warn('Firebase não configurado - usando APIs REST');
  // Criar objetos mock
  api = {
    firestore: () => ({
      collection: () => ({
        doc: () => ({
          get: () => Promise.resolve({ exists: false }),
          set: () => Promise.resolve(),
          update: () => Promise.resolve(),
          delete: () => Promise.resolve(),
          onSnapshot: () => () => {}, // Adicionar onSnapshot ao doc
        }),
        get: () => Promise.resolve({ docs: [] }),
        where: () => ({
          onSnapshot: () => () => {},
          get: () => Promise.resolve({ docs: [] }),
        }),
        orderBy: () => ({
          onSnapshot: () => () => {},
        }),
      }),
    }),
    auth: () => ({
      currentUser: null,
      onAuthStateChanged: () => () => {},
      sendPasswordResetEmail: () => Promise.resolve(),
    }),
    storage: () => ({
      ref: () => ({
        put: () => Promise.resolve({ ref: { getDownloadURL: () => Promise.resolve('') } }),
      }),
    }),
  };
  apiLogin = api;
}

export { apiLogin };
export default api;
